import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  accordionSummary: {
    '&.Mui-expanded': {
      backgroundColor: theme.palette.action.selected
    }
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    width: '100%'
  },
  noPadding: {
    padding: 0
  },
  countChip: {
    alignItems: 'center',
    backgroundColor: theme.palette.secondary.FP300,
    borderRadius: 999,
    display: 'flex',
    height: 32,
    justifyContent: 'center',
    minWidth: 32,
    padding: theme.spacing(0, 1)
  },
  innerAccordion: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
    '&:before': {
      display: 'none'
    }
  },
  innerAccordionSummary: {
    backgroundColor: theme.palette.grey[100]
  },
  innerAccordionDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(3)
  }
}));
